var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-menu"},[_c('span',{staticClass:"f-1"},[_vm._v(_vm._s(_vm.$store.getters['auth/getUserFullName'])+" | ")]),_c('AppLogout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }